import script from "./FilterTareas.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterTareas.vue?vue&type=script&setup=true&lang=js"

import "./FilterTareas.vue?vue&type=style&index=0&id=6eb71a7e&lang=css"

const __exports__ = script;

export default __exports__